import { render, staticRenderFns } from "./iconBlock.vue?vue&type=template&id=adb3e124&scoped=true"
import script from "./iconBlock.vue?vue&type=script&lang=js"
export * from "./iconBlock.vue?vue&type=script&lang=js"
import style0 from "./iconBlock.vue?vue&type=style&index=0&id=adb3e124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb3e124",
  null
  
)

export default component.exports